/* eslint-disable camelcase */
import color from './Color'
import size from './Size'
import quality from './Quality'
import effect from './Effect'
import chocolate_type from './ChocolateType'
import corner_radius from './CornerRadius'
import lamination from './Lamination'
import paper_type from './PaperType'
import diameter from './Diameter'
import frame_type from './FrameType'
import man_size from './ManSize'
import woman_size from './WomanSize'
import material from './Material'
import mug_color from './MugColor'
import notebook_cover from './NotebookCover'
import number_of_pages from './NumberOfPages'
import number_of_stickers from './NumberOfStickers'
import page_grid from './PageGrid'
import pillow_case from './PillowCase'
import pole from './Pole'
import dimension_size from './DimensionSize'

export default {
  color,
  size,
  quality,
  effect,
  chocolate_type,
  corner_radius,
  lamination,
  paper_type,
  diameter,
  frame_type,
  man_size,
  woman_size,
  material,
  mug_color,
  notebook_cover,
  notepad_cover: notebook_cover,
  number_of_pages,
  page_grid,
  number_of_stickers,
  pillow_case,
  pole,
  dimension_size,
}
